import { calculateEnvironmentByHost } from '@cian/utils/lib/shared/calculate_environment_by_host';
import declareCianSentryConfiguration from '@cian/sentry';

export const sentryConfiguration = () => {
  declareCianSentryConfiguration({
    dsn: '//8c414c90a37a47498afca119c147980a@sentry-front.cian.ru/3',
    environment: calculateEnvironmentByHost(window.location.host),
    release: (window.__mainpage_sentry__ && window.__mainpage_sentry__.release) || 'local',
    matchUrl: (url: string) => {
      return [/mainpage\.js/].some(re => re.test(url));
    },
  });
};
